<template>
    <div class="form-group">
        <label class="from-label" v-html="blockLabel">
        </label>
        <vue-slider
                ref="slider"
                v-model="selectedValue"
                :data="data"
                :tooltip-placement="'bottom'"
                :tooltip="'always'"
                :dotSize="[28, 28]"
                :min-range="1"
                :enableCross="false"
                :marks="true"
                :contained="true">
            <template v-slot:dot="{ value, focus }">
                <div class="custom-dot-inner"></div>
            </template>
            <template v-slot:step="{ label, active }">
                <div :class="['custom-step', { active }]"></div>
            </template>
            <template v-slot:label="{ label, active }">
                <div :class="['vue-slider-mark-label', 'custom-label', { active }]">{{ getValue(label, false) }}</div>
            </template>
            <template v-slot:tooltip="{ value }">
                <div class="custom-tooltip">{{ getValue(value, true) }}</div>
            </template>

        </vue-slider>
    </div>

</template>

<script>
    import VueSlider from 'vue-slider-component'
    export default {
        props: ['value', 'data', 'blockLabel', 'prefix'],
        components: {
            VueSlider,
        },
        data: function() {
            return {
                selected: [10, 20],
                tooltip: 'always',
                defaultPrefix: this.prefix,
            }
        },
        name: "Slider",
        computed: {
            selectedValue: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            },
        },
        methods: {
            getValue: function(label, always) {
                if (always) {
                    if (label !== this.data[0] && this.data[this.data.length - 1] !== label) {
                        return this.defaultPrefix + this.$options.filters.numberFormat(label);
                    } else {
                        return '';
                    }
                }
                if(label === this.data[0] || this.data[this.data.length-1] === label) {
                    return this.defaultPrefix + this.$options.filters.numberFormat(label);
                }
            }
        }
    }
</script>

<style lang="stylus">
    .vue-slider
        height 0.2rem !important
        margin: 20px auto 10px
        .vue-slider-rail
            border-radius: 0
            background-color: #a8adb3
            .vue-slider-mark
                &:first-child
                    .vue-slider-mark-label
                        transform translate(-20%, -200%)

                &:last-child
                    .vue-slider-mark-label
                        transform translate(-80%, -200%)
            .vue-slider-process
                background-color: #004666

            .vue-slider-dot
                border 0.2rem solid #66e4ee
                background-color #ffffff
                border-radius 50%
                padding: 6px
                &:nth-child(3)
                    .vue-slider-dot-tooltip
                        transform translate(-95%, 100%) !important

                &:last-of-type
                    .vue-slider-dot-tooltip
                        transform translate(-10%, 100%) !important

                &:hover
                    box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.3)

                .custom-dot-inner
                    background-color #004666
                    width: 12px
                    height: 12px
                    border-radius 50%
                    .vue-slider-dot-tooltip-bottom
                        bottom 0!important

            .vue-slider-dot-focus
                padding: 10px
                width: 40px !important
                height 40px !important

                .custom-dot-inner
                    width: 16px !important
                    height: 16px !important
                    border-radius 50%

            .vue-slider-dot-tooltip-inner
                background-color: #a8adb3
                border-color: #a8adb3
                border-radius: 0
                padding: 0
                font-weight: bold
                box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.3)
                font-size 1.4rem
                text-align center

                .text-wrap
                    display: block
                    width: 9rem
                    height: 100%
                    padding: 1.5rem 1rem
                    color: $color-font
                    background-color: #ffffff

            .vue-slider-dot-tooltip-inner-bottom
                &:after
                    top: -0.6rem
                    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOBAMAAADd6iHDAAAAIVBMVEUAAAAAAAAAAADg4OAAAAAAAAAAAADj4+Pr6+sAAAD////DLD5VAAAACnRSTlMACwSSGhEHkIsVJ0tVtwAAAE9JREFUCNdjQAVMakkKUKaaoGASVFB0RmcgRFgxpGq5qxBE0HnVKhOwMGOI1apVi10FgExWoCBQOADIZAEKAoUdgEzmVWBgAGRyQZgLCDMBNBQoHbW3FxwAAAAASUVORK5CYII=")
                    transform: translate(-50%, -25%)
                    border: 0
                    width: 2rem
                    height: 1.4rem
                    content:""
                    position absolute
                    left 50%
        .custom-step
            width 8px
            height 8px
            border-radius 50%
            background-color #a8adb3
            transform translateY(-40%)
            &.active
                background-color #004666
        .custom-label
            transform translate(-50%, -200%)
            font-size 15px
            line-height 28px
            display block
            font-family: "VWAGTheSansBold", Arial, sans-serif;
        .custom-tooltip
            color: #004666
            font-family: "VWAGTheSansBold", Arial, sans-serif;
</style>